import { UserProfile } from "@api/models/UserProfile";
import i18n from "@service/locale/i18";
import { DropDownItem } from "@share/common/drop-down/types";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";
import { required } from "vuelidate/lib/validators";

export const getSubjectsList = () => {
    return [
        {
            id: TicketType.idea,
            title: i18n.t("tickets.columns.idea").toString()
        },
        {
            id: TicketType.problem,
            title: i18n.t("tickets.columns.problem").toString()
        }
    ]
}

const selectControlRequired = (value: DropDownItem) => {
    return !!value.id;
}

const usersProfilesRequired = (value: UserProfile[]) => {
    return !!value.length;
}

/**
 * Return object with form fields with vuelidate validation settings
 * @param langList
 * @returns
 */
export const getValidationObject = () => {

    return {
        formModel: {
            subjectType: {
                required: selectControlRequired
            },
            company: {
                required: selectControlRequired
            },
            secretary: {
                required: selectControlRequired
            },
            title: {
                required
            },
            beginAt: {
                required
            },
            endAt: {
                required
            },
            userProfiles: {
                required: usersProfilesRequired
            }
        }
    }
}